package com.cybersoftsolution.cybersoftsolutionweb.components.dialogs

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.cybersoftsolution.cybersoftsolutionweb.components.buttons.CloseButtonX
import com.cybersoftsolution.cybersoftsolutionweb.components.buttons.GroupButtons
import com.cybersoftsolution.cybersoftsolutionweb.components.buttons.MyBorderRadius
import com.cybersoftsolution.cybersoftsolutionweb.components.buttons.MyButtonNew
import com.cybersoftsolution.cybersoftsolutionweb.components.buttons.MyButtonVariant
import com.cybersoftsolution.cybersoftsolutionweb.components.buttons.MyLoadingButton
import com.cybersoftsolution.cybersoftsolutionweb.components.buttons.profileMenu
import com.cybersoftsolution.cybersoftsolutionweb.components.capcha.SliderCaptchaBootstrap
import com.cybersoftsolution.cybersoftsolutionweb.components.icons.MyFaIcon
import com.cybersoftsolution.cybersoftsolutionweb.components.icons.MyIcons
import com.cybersoftsolution.cybersoftsolutionweb.components.text.MySpanText
import com.cybersoftsolution.cybersoftsolutionweb.components.textfield.InputTypeHTML
import com.cybersoftsolution.cybersoftsolutionweb.components.textfield.MyTextField
import com.cybersoftsolution.cybersoftsolutionweb.models.RestorePasswordParams
import com.cybersoftsolution.cybersoftsolutionweb.models.Theme
import com.cybersoftsolution.cybersoftsolutionweb.models.UserInfo
import com.cybersoftsolution.cybersoftsolutionweb.models.isValidInt
import com.cybersoftsolution.cybersoftsolutionweb.styles.GoogleButtonStyle
import com.cybersoftsolution.cybersoftsolutionweb.styles.LoginButtonStyle
import com.cybersoftsolution.cybersoftsolutionweb.styles.LoginStyle
import com.cybersoftsolution.cybersoftsolutionweb.styles.LogoutButtonStyle
import com.cybersoftsolution.cybersoftsolutionweb.styles.Selected_ItemStyle
import com.cybersoftsolution.cybersoftsolutionweb.use_cases.restorePasswordUseCase
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.confirmNewPasswordTextFieldId
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.googleAuthButtonId
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.logoutButtonId
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.newPasswordTextFieldId
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.otpExpireInSecTextId
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.otpTextFieldId
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.registerButtonId
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.restorePasswordButtonId
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.returnButtonId
import com.cybersoftsolution.cybersoftsolutionweb.utils.Resources
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontStyle
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.ScrollBehavior
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontStyle
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.scrollBehavior
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.layout.VerticalDivider
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.browser.document
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.delay
import org.jetbrains.compose.web.attributes.AutoComplete
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Form
import org.w3c.dom.HTMLButtonElement
import org.w3c.dom.HTMLInputElement

@Composable
inline fun ProfileDialog(
    rootModifier: Modifier = Modifier,
    breakpoint: Breakpoint,
    scope: CoroutineScope,
    context: PageContext,
    userInfo: UserInfo,
    errorText: String = " ",
    captchaVerified: Boolean = false,
    otpCode: String?=null,
    newPassword: String?,
    confirmNewPassword: String?,
    crossinline onClose: () -> Unit,
    crossinline onLogoutButtonClick: () -> Unit,
    crossinline setErrorText: (String) -> Unit,
    crossinline setOtpCode: (String?) -> Unit,
    crossinline setCaptchaVerified: (Boolean) -> Unit,
    crossinline setNewPassword: (String?) -> Unit,
    crossinline setConfirmNewPassword: (String?) -> Unit,
    crossinline onRestorePasswordFail:(errorMessage:String?) -> Unit,
    crossinline onRestorePasswordSuccess:(successMessage:String?) -> Unit,
    crossinline onRestorePasswordComplete:() -> Unit,
) {  // Recibe una función para cerrar el modal

    var showForgotPasswordDialog by remember { mutableStateOf(false) }
    var restorePasswordButtonLoading by remember{ mutableStateOf(false) }
    var step by remember { mutableStateOf(1) }
    var otpExpireInSec:Int by remember { mutableStateOf(0) }


    LaunchedEffect(otpExpireInSec) {
        if (otpExpireInSec > 0) {
            delay(1000)
            otpExpireInSec -= 1
        }
    }

    LaunchedEffect(step) {
        if (step==-1) {

            delay(50)
            onRestorePasswordComplete()
            showForgotPasswordDialog = false
            step = 1
        }
    }




    Box(
        contentAlignment = Alignment.TopStart,
        modifier = Modifier
            .thenIf(
                condition = breakpoint <= Breakpoint.SM,
                other = Modifier
                    .fillMaxWidth(95.percent)
//                    .height(95.percent)
            )
            .thenIf(
                condition = breakpoint == Breakpoint.MD,
                other = Modifier.width(500.px)
            )
            .thenIf(
                condition = breakpoint > Breakpoint.MD,
                other = Modifier.width(500.px)
            )
            .backgroundColor(Theme.LightGray.rgb)
            .borderRadius(15.px)
            .zIndex(80)
            .transition(Transition.of(property = TransitionProperty.All, duration = 300.ms))
            .overflow(Overflow.Auto)
            .scrollBehavior(ScrollBehavior.Smooth)
            .then(rootModifier)


    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .backgroundColor(Theme.Primary.rgb)
                .height(120.px)
        ) {

        }

        Column(
            verticalArrangement = Arrangement.Top,
            horizontalAlignment = Alignment.CenterHorizontally,
            modifier = Modifier
                .fillMaxSize()
                .transition(Transition.of(property = TransitionProperty.All, duration = 300.ms))
        ) {
            Row(
                horizontalArrangement = Arrangement.End,
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(8.px)
            ) {
                CloseButtonX(
                    onClick = { onClose() }
                )
            }


            Image(
                width = 120,
                height = 120,
                modifier = Modifier
                    .border(
                        width = 3.px,
                        style = LineStyle.Solid,
                        color = Theme.LightGray.rgb
                    )
                    .margin(top = 10.px)
                    .borderRadius(100.px), // Bordes redondeados para la imagen,
                src = userInfo.picture ?: Resources.Images.profilePlaceholder,
                alt = userInfo.name ?: "Imagen de perfil",
            )


            MySpanText(
                text = userInfo.name,
//                fontColor = Theme.HalfBlack.rgb,
                fontSize = 20,
                modifier = Modifier
                    .textAlign(TextAlign.Center)
//                    .margin(top = 5.px)
            )

            if (!userInfo.phone.isNullOrEmpty()) {
                MySpanText(
                    text = userInfo.phone,
                    fontColor = Theme.HalfBlack.rgb,
                    fontSize = 16,
                    modifier = Modifier
                        .textAlign(TextAlign.Center)
//                        .margin(top = 5.px)
                )
            }
            Row(
                horizontalArrangement = Arrangement.Center,
                verticalAlignment = Alignment.CenterVertically,
                modifier = Modifier
                    .fillMaxWidth()
//                    .margin(top = 5.px)
            ) {
                SpanText(
                    modifier = Modifier
                        .fontSize(16.px)
                        .fontStyle(FontStyle.Normal)
                        .color(Theme.HalfBlack.rgb),
                    text = userInfo.email.orEmpty()
                )
                MyFaIcon(
                    modifier = Modifier
                        .margin(left = 10.px)
                        .thenIf(
                            condition = userInfo.emailVerified==true,
                            other = Modifier
                                .color(Colors.ForestGreen)
                        )
                        .thenIf(
                            condition = userInfo.emailVerified!=true,
                            other = Modifier
                                .cursor(Cursor.Pointer)
                                .color(Theme.Red.rgb)
                        ),
                    style = if (userInfo.emailVerified!=true) Selected_ItemStyle else null,
                    id = "emailVerifiedButtonIcoId",
                    faIconsClassName = Resources.FaIconsClassName.CirlceCheck_ICO,

                )
            }



                //Todo Working

                if (showForgotPasswordDialog) {

                    Column(
                        verticalArrangement = Arrangement.Top,
                        horizontalAlignment = Alignment.Start,
                        modifier = Modifier
                            .fillMaxWidth(90.percent)
                            .padding(20.px)
                            .margin(top = 20.px)
                            .backgroundColor(Theme.LightDarkGray.rgb)
                            .borderRadius(10.px)

                    ){
                        Row(
                            horizontalArrangement = Arrangement.Start,
                            verticalAlignment = Alignment.CenterVertically,
                            modifier = Modifier
                                .fillMaxWidth()
                                .margin(bottom = 24.px)
                        ) {

                            MyButtonNew(
                                modifier = Modifier
                                    .fillMaxHeight(),
                                style = LoginButtonStyle,
                                id = returnButtonId,
                                borderRadius = 5.px,
                                text = "Volver",
                                textColor = Colors.Black,
                                fontSize = 13,
                                faIconsClassName = Resources.FaIconsClassName.ArrowBack_ICO,
                                onClick = {
                                    showForgotPasswordDialog = false
                                }
                            )
                        }

                        Form(
                            attrs = Modifier
                                .fillMaxWidth()
                                .toAttrs {  }
                        ) {
                            when (step) {
                                1 -> {

                                    SliderCaptchaBootstrap(
                                        verified = captchaVerified,
                                        useErrorMessages = false,
                                        modifier = Modifier
                                            .margin(bottom = 24.px),
                                        onVerified = {
                                            setCaptchaVerified(true)
                                        },
                                        onError = { errorMessage ->
                                            setCaptchaVerified(false)
                                        }
                                    )
                                }
                                2 -> {
                                    Column(
                                        modifier = Modifier
                                            .margin(bottom = 24.px)
                                    ) {
                                        MyTextField(
                                            id = otpTextFieldId,
                                            modifier = Modifier
                                                .fillMaxWidth()

                                                .height(50.px)
                                                .padding(leftRight = 10.px)
                                                .margin(bottom = 8.px)
                                                .fontSize(16.px)
                                                .borderRadius(10.px)
                                            ,
                                            maxLength = 6,
                                            text = otpCode,
                                            autoComplete = AutoComplete.oneTimeCode,
                                            style = LoginStyle,
                                            inputTypeHTML = InputTypeHTML.Text,
                                            //                        id = otpTextField,
                                            placeholder = "Codigo de Verificacion",
                                            onChange = {
                                                if (it.isValidInt()) setOtpCode(it) else setOtpCode(null)
                                            },
                                            onEnter = {
                                                (document.getElementById(restorePasswordButtonId) as HTMLInputElement).focus();
                                            }

                                        )

                                        SpanText(
                                            text = if (otpExpireInSec > 0) "El código de verificación expirará en $otpExpireInSec segundo/s" else "Tiempo agotado, solicite nuevamente",
                                            modifier = Modifier
                                                .fillMaxWidth()
                                                .textAlign(TextAlign.Justify)
                                                .id(otpExpireInSecTextId)
                                                .color(if (otpExpireInSec > 0) Theme.HalfBlack.rgb else Colors.Red)
                                                .fontWeight(FontWeight.Normal)
                                                .fontSize(FontSize.Small)

                                        )
                                    }






                                }
                                3 -> {

                                    MyTextField(
                                        id = newPasswordTextFieldId,
                                        modifier = Modifier
                                            .fillMaxWidth()
                                            .height(50.px)
                                            .padding(leftRight = 10.px)
                                            .margin(bottom = 24.px)
                                            .fontSize(16.px)
                                            .borderRadius(10.px),
                                        text = newPassword,
//                        autoComplete = AutoComplete.name,
                                        style = LoginStyle,
                                        inputTypeHTML = InputTypeHTML.Password,
                                        placeholder = "Establezca su contraseña",
                                        onChange = { setNewPassword(it) },
                                        onEnter = {
                                            (document.getElementById(confirmNewPasswordTextFieldId) as HTMLButtonElement).focus();
                                        }

                                    )

                                    MyTextField(
                                        id = confirmNewPasswordTextFieldId,
                                        modifier = Modifier
                                            .fillMaxWidth()
                                            .height(50.px)
                                            .padding(leftRight = 10.px)
                                            .margin(bottom = 24.px)
                                            .fontSize(16.px)
                                            .borderRadius(10.px),
                                        text = confirmNewPassword,
//                        autoComplete = AutoComplete.email,
                                        style = LoginStyle,
                                        inputTypeHTML = InputTypeHTML.Password,
                                        placeholder = "Confirme su contraseña",
                                        onChange = {
                                            setConfirmNewPassword(it)
                                        },
                                        onEnter = {
                                            (document.getElementById(registerButtonId) as HTMLButtonElement).focus();
                                        }

                                    )

                                }
                                else -> {

                                }

                            }
                        }



                        MyLoadingButton(
                            modifier = Modifier
                                .fillMaxWidth()
                                .height(38.px),
                            id = restorePasswordButtonId,
                            text = when (step) {
                                1 -> if (captchaVerified) "Solicitar OTP" else "Resuelve el Captcha"
                                2 -> { if (otpExpireInSec > 0) {
                                    "Continuar"
                                } else "Solicitar OTP"
                                }
                                else -> "Establecer Contraseña"
                            },
                            variant = when (step) {
                                1 -> MyButtonVariant.Warning
                                2 -> { if (otpExpireInSec > 0) {
                                    MyButtonVariant.Warning
                                } else MyButtonVariant.Danger
                                }
                                else -> MyButtonVariant.Warning
                            },
                            borderRadius = MyBorderRadius(5.px),

                            disabled = !captchaVerified,
                            loading = restorePasswordButtonLoading,
                            icon = when (step) {
                                1 -> MyIcons.ENVELOPE_AT_FILL
                                2 -> { if (otpExpireInSec > 0) {
                                    MyIcons.ENVELOPE_CHECK_FILL
                                } else MyIcons.ENVELOPE_AT_FILL
                                }
                                else -> MyIcons.KEY_FILL
                            },
                            onClick = {
                                if (!captchaVerified) {
                                    return@MyLoadingButton
                                }

                                if (step==3) {
                                    if (newPassword.isNullOrEmpty()) {
                                        onRestorePasswordFail("Por favor ingrese una contraseña")
                                        return@MyLoadingButton
                                    }
                                    if (confirmNewPassword.isNullOrEmpty()) {
                                        onRestorePasswordFail("Confirme su contraseña")
                                        return@MyLoadingButton
                                    }
                                    if (newPassword != confirmNewPassword) {
                                        onRestorePasswordFail("Las contraseñas no coinciden")
                                        return@MyLoadingButton
                                    }
                                }

                                restorePasswordButtonLoading = true

                                scope.restorePasswordUseCase(
                                    step = step,
                                    setStep = {
                                        step = it
                                    },
                                    refreshOtpExpireInSec = { it ->
                                        otpExpireInSec = it?.toInt() ?: 0
                                    },
                                    restorePasswordParams = RestorePasswordParams(
                                        email = userInfo.email.orEmpty(),
                                        otp = when (step) {
                                            1 -> otpCode?.toInt()
                                            2 -> { if (otpExpireInSec > 0) {
                                                otpCode?.toInt()
                                            } else null
                                            }
                                            else -> otpCode?.toInt()
                                        },
                                        password = when (step) {
                                            3 -> newPassword.orEmpty()
                                            else -> null
                                        },
                                    ),
                                    setErrorText = {
//                                setErrorText(it)
                                        onRestorePasswordFail(it)
                                    },
                                    onSuccess = { successMessage ->
                                        restorePasswordButtonLoading = false
//                                        onRestorePasswordSuccess(successMessage)
                                        if (successMessage =="Contraseña restablecida y sesión iniciada")  {
                                            onRestorePasswordSuccess("Contraseña establecida satisfactoriamente")
                                        } else {
                                            onRestorePasswordSuccess(successMessage)
                                        }


                                    },
                                    onFail = { errorMessages ->
//                                console.log("Sign Error message: $errorMessages")
                                        restorePasswordButtonLoading = false
                                        onRestorePasswordFail(errorMessages)

                                    }
                                )



                            }
                        )


                        SpanText(
                            text = errorText,
                            modifier = Modifier
                                .fillMaxWidth()
                                .textAlign(TextAlign.Center)
                                .id(errorText)
                                .color(Colors.Red)
                                .padding(leftRight = 24.px)
//                        .margin(bottom = 24.px)
                                .fontWeight(FontWeight.Light)
                                .fontSize(FontSize.Medium)

                        )


                    }


                } else {


                    Column(
                        verticalArrangement = Arrangement.Top,
                        horizontalAlignment = Alignment.CenterHorizontally,
                        modifier = Modifier
                            .fillMaxWidth(90.percent)
                            .padding(20.px)
                            .margin(top = 20.px)
//                    .backgroundColor(Theme.LightDarkGray.rgb)
//                    .borderRadius(10.px)
                    ) {
                        GroupButtons(
                            elements = profileMenu,
                            id = "profileMenuId",
                            onMenuClick = { id ->
                                when (id) {
                                    "changePasswordMenuId" -> {
                                        showForgotPasswordDialog = true
                                    }
                                }

                            }

                        )
                    }

                }








            MySpanText( //aun no tienes una cuenta
                text = "${userInfo.name} gracias por ser parte de nuestra comunidad",
                fontColor = Theme.HalfBlack.rgb,
                fontSize = 15,
                modifier = Modifier
                    .fillMaxWidth(90.percent)
                    .textAlign(TextAlign.Center)
                    .margin(top = 20.px)
            )

            MyButtonNew(
                modifier = Modifier
                    .height(60.px)
                    .minHeight(60.px)
                    .width(90.percent)
                    .borderRadius(15.px)
                    .margin(bottom = 24.px, top = 12.px),
                style = LogoutButtonStyle,
                id = logoutButtonId,
                borderRadius = 15.px,
                text = "Cerrar Sesión",
                faIconsClassName = Resources.FaIconsClassName.Register_User_ICO,
                fontSize = 18,
                onClick = {
                    onLogoutButtonClick()
                }
            )


            FooterSectionDialog()





        }
    }
}